module.exports = __webpack_public_path__ + "static/media/left-arrow-gray.f8127f83.svg";